import MainLayout from '@/common/components/layouts/MainLayout';
import { PropsWithChildren } from 'react';

const PropertyCulpritInsurance = ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title={' مقصر / بیمه شخص ثالث '} header="titleHeader">
      {children}
    </MainLayout>
  );
};

export default PropertyCulpritInsurance;
